var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.theme,attrs:{"target":"_blank","href":_vm.link,"rel":_vm.rel}},[_c('div',{staticClass:"status-container"},[_c('div',{class:[{ 'status-indicator': _vm.indicator !== '' }, _vm.indicator]}),_vm._v(" "),_c('div',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.statusText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }